module.exports = __webpack_public_path__ + "static/media/1014038.af927295.png";